import { kcMessages } from "keycloakify";
import { termsTextEn} from "./Terms";

Object.assign(
	kcMessages["fr"],
	{
		/* spell-checker: disable */
		"gender": "Genre",
		/* spell-checker: enable */
	}
);

Object.assign(
	kcMessages["en"],
	{
		"gender": "Gender",
		"termsText": termsTextEn
	}
);
